import { Trans, useTranslation } from 'react-i18next'
import Warning from '../icons/warning'

interface MessageBlockProps {
  type?: string
  show?: boolean
  children: React.ReactNode
}

export const MessageBlock = ({ type, show = true, children }: MessageBlockProps) => {
  if (!show) {
    return null
  }

  return (
    <div className={type}>
      {type !== 'fee' && <Warning className="inline-block mr-3" />}
      {children}
    </div>
  )
}

export default MessageBlock
